import { Asset2TranscodingStatus } from '../../../../../../apis/graphql';
import type { ValueOf } from '../../../../types/util';
import type { StatusLabel } from '../types';
import { StageLabels } from '../types';
import { LabelType } from './LabelType';

export const validTranscodeStatusListAsset2: string[] = [
  Asset2TranscodingStatus.Accepted,
  Asset2TranscodingStatus.Completed,
  Asset2TranscodingStatus.Processing,
  Asset2TranscodingStatus.Publishing,
  Asset2TranscodingStatus.Failed,
  Asset2TranscodingStatus.Rejected,
];

const successTranscodeV2Statuses: string[] = [Asset2TranscodingStatus.Accepted, Asset2TranscodingStatus.Completed];
const errorTranscodeV2Statuses: string[] = [Asset2TranscodingStatus.Failed, Asset2TranscodingStatus.Rejected];

export function getTranscodeLabelAsset2(status?: string | null): StatusLabel {
  if (!status || !validTranscodeStatusListAsset2.includes(status)) return null;

  let type: ValueOf<typeof LabelType> = LabelType.IN_PROGRESS;

  if (successTranscodeV2Statuses.includes(status)) type = LabelType.SUCCESS;
  if (errorTranscodeV2Statuses.includes(status)) type = LabelType.ERROR;

  return {
    label: status,
    type,
    stage: StageLabels.Transcode,
  };
}
